import React, { FunctionComponent, RefObject } from 'react'

import { Person } from '../../App/store/features/person/IPerson'
import { AmountOfCalendarDaysButton } from '../AmountOfCalendarDaysButton'
import { ContrastPicker } from '../ContrastPicker'
import { UserPicker } from '../UserPicker'
import { ZoomInOutPicker } from '../ZoomInOutPicker'

import { CalendarSettingsPanel, SlidersSettingsWrapper } from './style'

interface IProps {
  isSettingsOpen: boolean
  persons: Person[]
  settingContainerRef: RefObject<HTMLDivElement>
}

export const CalendarToolbarSettings: FunctionComponent<IProps> = ({
  isSettingsOpen,
  persons,
  settingContainerRef,
}) => {
  if (!isSettingsOpen) {
    return null
  }

  return (
    <CalendarSettingsPanel ref={settingContainerRef}>
      <AmountOfCalendarDaysButton />

      <UserPicker persons={persons} />

      <SlidersSettingsWrapper>
        <ContrastPicker />

        <ZoomInOutPicker />
      </SlidersSettingsWrapper>
    </CalendarSettingsPanel>
  )
}
